import update from 'immutability-helper';
import {
  INFO_CONSOLE_TOGGLE,
  MOBILE_WELCOME_ACKNOWLEDGE,
  SLIDE_ROTATION_PAUSE_TOGGLE,
  INVITE_RECEIVE,
  UI_MODE_SET,
  SCROLL_LOCK_SET,
  COMPONENT_FOCUS_SET
} from '../actions/ActionTypes';

import getReadStatusKeyName from '../utils/getReadStatusKeyName.js';

const initialState = {
  mode: 'slideshow',
  console: {
    isOpen: false,
  },
  isMobileWelcomeAcknowledged: false,
  slideRotation: {
    isPaused: false
  },
  isScrollLocked: false,
  prevComponentFocusId: null,
  componentFocusId: null
};

export function ui(state = initialState, action) {
  const {type, payload = {}} = action;

  switch (type) {
  case UI_MODE_SET:
    return update(state, {
      mode: {
        $set: payload.mode
      }
    });
  case INFO_CONSOLE_TOGGLE: {
    return update(state, {
      console: {
        $toggle: ['isOpen']
      }
    });
  }
  case INVITE_RECEIVE: {
    return update(state, {
      isMobileWelcomeAcknowledged: {
        $set: localStorage.getItem(getReadStatusKeyName(payload)) !== null
      }
    });
  }
  case MOBILE_WELCOME_ACKNOWLEDGE: {
    return update(state, {
      isMobileWelcomeAcknowledged: {
        $set: true
      }
    });
  }
  case SLIDE_ROTATION_PAUSE_TOGGLE: {
    return update(state, {
      slideRotation: {
        $toggle: ['isPaused']
      }
    });
  }
  case SCROLL_LOCK_SET: {
    return update(state, {
      isScrollLocked: {
        $set: payload.shouldScrollLock
      }
    });
  }
  case COMPONENT_FOCUS_SET: {
    return update(state, {
      componentFocusId: {
        $set: payload.id
      },
      isScrollLocked: {
        $set: payload.id !== null
      }
    });
  }
  default:
    return state;
  }
}
